import React, { Children } from 'react';

import { ISpecOfferBenefitBanner } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/dto/ISpecOffer';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BlockContainer, IndentContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

import Benefit from '~/src/entities/vases/PartnerServices/components/ServiceDetails/components/Benefits/Benefit';

interface IProps {
    benefits?: ISpecOfferBenefitBanner[],
    className?: string,
}

const Benefits = ({ benefits, className }: IProps): JSX.Element | null => {
    const isDesktop = useMatchMediaByWidth(wideBreakpoints.mobile, true);

    if (!benefits?.length) {
        return null;
    }

    return (
        <IndentContainer $desktop={[0, 32]} $mobile={[0, 24]} className={className}>
            <BlockContainer
                indent={{ $united: [0] }}
                rounder={{ $desktop: 32, $mobile: 24 }}
                bgColor={isDesktop ? COLORS.transparent : COLORS.BgMain}
                data-test='benefits-container'
            >
                <ListContainer
                    $direction={isDesktop ? 'row' : 'column'}
                    $wrap={'nowrap'}
                    $desktop={16}
                    $mobile={12}
                    data-test='benefits-list'
                >
                    {Children.toArray(benefits.map(benefit => <Benefit title={benefit.title} image={benefit.lightThemeImage}/>))}
                </ListContainer>
            </BlockContainer>
        </IndentContainer>
    );
};

export default Benefits;
